export const US_STATES_LABEL_MAP = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

export type US_STATES_LABEL_MAP_KEYS = keyof typeof US_STATES_LABEL_MAP;

const US_DISTRICTS_AND_TERRITORIES_LABEL_MAP = {
  DC: 'District of Columbia',
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  VI: 'Virgin Islands',
  AA: 'Armed Forces America',
  AE: 'Armed Forces Europe',
  AP: 'Armed Forces Pacific',
  PW: 'Palau',
  TT: 'Trust Territories',
  UM: 'United States Minor Outlying Islands',
} as const;

const CANADA_PROVINCES_LABEL_MAP = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NT: 'Northwest Territories',
  NS: 'Nova Scotia',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Québec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
} as const;

export const ALL_US_STATES_AND_TERRITORIES_MAP = {
  ...US_STATES_LABEL_MAP,
  ...US_DISTRICTS_AND_TERRITORIES_LABEL_MAP,
};

export const CANADA_PROVINCES_MAP = CANADA_PROVINCES_LABEL_MAP;

export const ALL_US_STATES_TERRITORIES_AND_CANADA_MAP = {
  ...ALL_US_STATES_AND_TERRITORIES_MAP,
  ...CANADA_PROVINCES_MAP,
};

export const US_STATES_AND_DC_MAP = {
  ...US_STATES_LABEL_MAP,
  DC: US_DISTRICTS_AND_TERRITORIES_LABEL_MAP.DC,
};
